import { Injectable } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import * as confetti from 'canvas-confetti';

const SHARED_ASSETS_PATH = 'assets/animations/shared';

@Injectable({
  providedIn: 'root'
})
export class AnimationService {
  private prefersReducedMotion = false;

  constructor() {
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
      this.prefersReducedMotion = e.matches;
    });
  }

  get isReducedMotion(): boolean {
    return this.prefersReducedMotion;
  }

  getLottieOptions(animationName: string, loop: boolean = false, basePath: string = SHARED_ASSETS_PATH): AnimationOptions {
    return {
      path: `${basePath}/${animationName}`,
      loop,
      autoplay: !this.prefersReducedMotion
    };
  }

  onAnimationCreated(animation: AnimationItem): void {
    if (this.prefersReducedMotion) {
      animation.goToAndStop(animation.totalFrames - 1, true);
    }
  }

  playSuccessCheck(): AnimationOptions {
    return this.getLottieOptions('success-check.json', false);
  }

  fireConfetti(options?: confetti.Options): void {
    if (this.prefersReducedMotion) return;
    const defaults: confetti.Options = {
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    };
    (confetti as any)({ ...defaults, ...options });
  }
}
